
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10Api'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: {
      type: String,
      default: function() {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 0,
      activeTagLabel: '全部公告',
      total: 0,
      size: 10,
      pagination: {},
      spinning: true,
      key: Math.random()
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: number) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: false
      }
    })
    pageData.tags = [
      {
        label: '全部公告',
        value: 0
      },
      {
        label: '业绩公告',
        value: 3
      },
      {
        label: '重大事项',
        value: 6
      },
      {
        label: '股份变动公告',
        value: 4
      },
      {
        label: '决议公告',
        value: 5
      }
    ]
    pageData.columns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: '100px'
      },
      {
        title: '公告标题',
        dataIndex: 'ggTitle',
        key: 'ggTitle',
        ellipsis: true,
        slots: { customRender: 'link', type: 'link' }
        // slots: { customRender: "name" }
      }
    ]
    watch(
      () => ((props.pageSourceData || {}).Notice || {}).NewsOrNoticeDataData,
      () => {
        pageData.total = ((props.pageSourceData || {}).Notice || {}).Total
        const data = ((props.pageSourceData || {}).Notice || {}).NewsOrNoticeDataData
        pageData.data = handlerData(data)
        nextTick(() => {
          pageData.spinning = false
        })
      }
    )

    const route = useRoute()
    function getDetail(PageID: number, PageSize: number, tag: number) {
      const data: any = {}
      data.data = {
        ExchInst: [
          {
            Exch: route.query.market,
            Inst: route.query.code
          }
        ],
        Org: [2],
        Tp: [2],
        Tp2: [tag],
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getGszxDetail(data).then((res: any) => {
        const arr = ((res.Data || {}).NewsV2Data || []).slice(0, 100)
        pageData.data = handlerData(arr)
        pageData.total = arr.length
        pageData.key = Math.random()
        nextTick(() => {
          pageData.spinning = false
        })
      })
    }
    function handlerData(arr: any) {
      if ((arr || []).length < 1) return []
      arr.forEach((item: any, i: number) => {
        item.index = 'GszxDetail' + i
        item.date = window.moment(item.PubTime * 1000).format('YYYY-MM-DD')
        item.ggTitle = item.Title
      })
      return arr
    }
    function checkTag(tag: any) {
      pageData.spinning = true
      pageData.activeTagVal = tag.value
      pageData.activeTagLabel = tag.label
      if (pageData.activeTagVal === 0) {
        pageData.total = ((props.pageSourceData || {}).Notice || {}).Total
        const data = ((props.pageSourceData || {}).Notice || {}).NewsOrNoticeDataData
        pageData.data = handlerData(data)
        nextTick(() => {
          pageData.spinning = false
        })
      } else {
        getDetail(1, 100, tag.value)
      }
    }
    return {
      ...toRefs(pageData),
      checkTag
    }
  }
})
